/**
 * Venue flow grouping — the single source of truth. Three explicit types:
 *  - SN and CGG each run the "regular" purchase flow (with their own theme).
 *  - STT-like venues (STT + IMAX, and any future STT-style venue) run the STT flow.
 * Nothing defaults to STT: a venue is STT-like only if it is listed here explicitly.
 * The membership check is exposed as `VenueDataAccessor.isSttLikeFlow`.
 */
export const STT_LIKE_VENUES: readonly SNDomainData['venueName'][] = ['stt', 'imax'];
